var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// -------------------------------------------------------
// NOTE: This is a generated file, do not manually modify!
// -------------------------------------------------------
import { SvgIcon } from '@mui/material';
import { notificationSuccess as paths } from '../../icon-paths';
export var Success = function (props) { return (_jsx(SvgIcon, __assign({ viewBox: "0 0 16 16" }, props, { children: paths.map(function (pathString, i) { return (_jsx("path", { d: pathString }, i)); }) }))); };
Success.iconCategory = 'notification';
